export default __webpack_public_path__ + "static/peer_support-daf892ba16e347680e9a99b5f6b31700.png";